import { Sparkles, MapPin, Send, CheckCircle2, CalendarDays, Clock, CheckCheck, Star } from "lucide-react";

export const STAGE_META = {
  new_lead:            { label: "New Lead",            color: "#3B82F6", icon: Sparkles },
  site_visit_scheduled:{ label: "Site Visit Scheduled",color: "#8B5CF6", icon: MapPin },
  proposal_sent:       { label: "Proposal Sent",       color: "#F97316", icon: Send },
  proposal_accepted:   { label: "Proposal Accepted",   color: "#4ADE80", icon: CheckCircle2 },
  scheduled:           { label: "Scheduled",           color: "#14B8A6", icon: CalendarDays },
  in_progress:         { label: "In Progress",         color: "#F59E0B", icon: Clock },
  completed:           { label: "Completed",           color: "#22C55E", icon: CheckCheck },
  recurring_client:    { label: "Recurring Client",    color: "#059669", icon: Star },
};
export const STAGE_ORDER = Object.keys(STAGE_META);
export const WON_STAGES = ["completed", "recurring_client"];
export const PRIORITY_META = {
  high:   { label: "High",   color: "#EF4444" },
  medium: { label: "Medium", color: "#F59E0B" },
  low:    { label: "Low",    color: "#64748B" },
};
export const money = (n) => `CA$${Number(n || 0).toLocaleString()}`;
export const fmtDate = (d) => d ? new Date(d).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : "—";
export const fmtDateTime = (d) => d ? new Date(d).toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";
export const todayISO = () => new Date().toISOString().slice(0, 10);
export const isOverdue = (lead) => lead.follow_up_date && !WON_STAGES.includes(lead.stage) && lead.follow_up_date < todayISO();
export const acv = (lead) => (Number(lead.estimated_monthly_value) || 0) * 12;
